/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ./images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
//const images = require.context('./images', true)
// const imagePath = (name) => images(name, true)

// Just for HMR
import "../../assets/stylesheets/application.css"
import "../../assets/builds/tailwind.css"

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

import ahoy from "ahoy.js"

import { load as fingerprintjs } from '@fingerprintjs/botd'
import 'altcha'

const botdPromise = fingerprintjs()

const setupAHoyListeners = ()=>{
	Array.from(document.getElementsByClassName('track_click')).forEach(element =>{
		element.addEventListener('click', ({ target })=>{
			ahoy.track('$click', { name: target.dataset.trackName })
		})
	})
}

//window.botdPromise = botdPromise

const setupSendFeedbackListener = ()=> {
	const send_feedback = document.getElementById('send-feedback-form')

	if(send_feedback){
		botdPromise.then(bot_detect => bot_detect.detect()).then( result => {
			const input = document.createElement('input')

			input.type = 'hidden'
			input.name = 'btest'

			input.value = JSON.stringify(result)

			send_feedback.appendChild(input)
		})
	}
}

const isRootLocation = () => window.location.pathname === '/'

const setupSendFeedbackMessage = () => {
	const send_feedback_message = document.getElementById("send-feedback-message")

	if(!send_feedback_message){
		return
	}

	const showIfIsRootLocation = ()=> {
		if(isRootLocation()) {
			send_feedback_message.classList.remove('hidden')
		} else {
			send_feedback_message.classList.add('hidden')
		}
	}

	showIfIsRootLocation()

	// TODO:
	// Thanks ChatGPT, i hate you JS in browsers
	// I know it's an architectonic bug in first place
	// But i need to solve it quickly for a demo
	// No room for deep arch changes
	let lastUrl = location.href;

	setInterval(() => {
	  if (location.href !== lastUrl) {
	    lastUrl = location.href;

	    showIfIsRootLocation()
	  }
	}, 200);

	window.addEventListener('popstate', showIfIsRootLocation)
}

const setupNoticeFlashFadeOut = () => {
	const notices = Array.from(document.getElementsByClassName('notice-flash'))

	if(isRootLocation() && notices.length){
		setTimeout(()=>{
			notices.forEach(notice => {
				notice.classList.remove('opacity-100')
				notice.classList.add('opacity-0')
			})
		}, 2000)
	}
}

const setupLoadingSpinnerFadeOut = () => {
	const loading_spinner = document.getElementById("loading-spinner")

	if(!loading_spinner){
		return
	}

	loading_spinner.classList.add('hidden')
}

addEventListener("DOMContentLoaded", () => {
	setupAHoyListeners()
	setupSendFeedbackListener()
	setupSendFeedbackMessage()
	setupNoticeFlashFadeOut()
	//setupLoadingSpinnerFadeOut()
})

const stimulus = Application.start()

// TODO: make env dependent
//stimulus.debug = true

//window.Stimulus = stimulus

const context = require.context("../controllers", true, /\.js$/)
stimulus.load(definitionsFromContext(context))

import ThumbnailSelectController from "../controllers/thumbnail_select_controller"
import MenuToggleController from "../controllers/menu_toggle_controller"

stimulus.register("thumbnail_select", ThumbnailSelectController)
stimulus.register("menu_toggle", MenuToggleController)

//ahoy.debug()
ahoy.trackView()
//window.ahoy = ahoy
